import React, { useState } from 'react';
import MaterialTable, { MTableToolbar } from "material-table";
import { Link, useNavigate } from "react-router-dom";
import "react-sliding-pane/dist/react-sliding-pane.css";
import _ from "lodash";
import { confirmAlert } from "react-confirm-alert"; 
import { ToastContainer,toast } from "react-toastify";
import { getTrans as t } from "../../Localization/translations";
import { API } from '../../backend';
import authHeader from '../../services/auth-header';
import jsPDF from 'jspdf';
import ACHproviderServices from "../../services/ACHproviders/ACHproviderServices";
import { autoTable } from 'jspdf-autotable'

const AchProviders = ({ customerPermission }) => {
    const AchtableRef = React.createRef();

    const [permissions] = useState(localStorage.getItem("permissions") || "");
    const [totalCount, setTotalCount] = useState(0);
    const permissionsArray = permissions.split(",");
    const navigate = useNavigate();

    const handleEdit = (id) => {
        navigate("/editachprovider", { state: id });
    };
    
    const handleView = (id) => {
        navigate("/viewachprovider", { state: id });
    };

    const handelDelete = (id) => {
        // confirmAlert({
        //   title: "",
        //   message: "Are you sure you want to delete this Tax Rate?.",
        //   buttons: [
        //     {
        //       label: "Yes",
        //       onClick: () => {
        //         TaxRatesService.TaxRateDelete(id).then((response) => {
        //           if (response.data.success) {
        //             toast.success(`${response.data.response}`, {
        //               position: "top-right",
        //               autoClose: 1000,
        //               hideProgressBar: false,
        //               pauseOnHover: true,
        //               draggable: true,
        //               progress: undefined,
        //               theme: "light",
        //             });
        //             tableRef.current.onQueryChange();
        //           } else {
        //             toast.error(`${response.data.error}`, {
        //               position: "top-right",
        //               autoClose: 1000,
        //               hideProgressBar: false,
        //               pauseOnHover: true,
        //               draggable: true,
        //               progress: undefined,
        //               theme: "light",
        //             });
        //           }
        //         });
        //       },
        //     },
        //     {
        //       label: "No",
        //     },
        //   ],
        // });
      };

    return (
        <div className="mt-2">
            <ToastContainer />
            <div className="content container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="body">
                            <div className="p-0">
                                <MaterialTable
                                    tableRef={AchtableRef}
                                    style={{
                                        backgroundColor: "var(--bs-table-bg)",
                                        borderBottomWidth: "1px",
                                        boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                    }}
                                    title={<h5 className="d-lg-flex">{t("ACH Provider")}</h5>}
                                    columns={[
                                    {
                                        title: t("ACH Operator Name"),
                                        field: "ach_operator_name",
                                        render: (rowData) => (
                                            <>
                                            <div className={`d-xl-none tc d-md-none d-lg-none`}
                                            >
                                                {t("ACH Operator Name")}
                                            </div>
                                        <div
                                            className="hyperlink"
                                            onClick={() => handleView(rowData.id)}
                                        >
                                            {rowData.ach_operator_name}
                                        </div>
                                        </>
                                        ),
                                        headerStyle: {
                                        verticalAlign: "inherit",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        },
                                        cellStyle: {
                                        textAlign: "left",
                                        fontSize: 12,
                                        },
                                    },
                                    {
                                        title: t("Destination"),
                                        field: "destination",
                                        render: (rowData) => (
                                            <>
                                            <div className={`d-xl-none tc d-md-none d-lg-none`}
                                            >
                                                {t("Destination")}
                                            </div>
                                        <div
                                            className="col-lg-8 view-label p"
                                            onClick={() => handleView(rowData.id)}
                                            >
                                            {rowData.destination}
                                        </div>
                                            </>
                                        ),
                                        headerStyle: {
                                        verticalAlign: "inherit",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        },
                                        cellStyle: {
                                        textAlign: "left",
                                        fontSize: 12,
                                        },
                                    },
                                    {
                                        title: t("Destination Name"),
                                        field: "destination_name",
                                        render: (rowData) => (
                                            <>
                                            <div className={`d-xl-none tc d-md-none d-lg-none`}
                                            >
                                                {t("Destination Name")}
                                            </div>
                                        <div
                                            className="col-lg-8 view-label p"
                                            onClick={() => handleView(rowData.id)}
                                            >
                                            {rowData.destination_name}
                                        </div>
                                            </>
                                        ),
                                        headerStyle: {
                                        verticalAlign: "inherit",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        },
                                        cellStyle: {
                                        textAlign: "left",
                                        fontSize: 12,
                                        },
                                    },
                                    {
                                        title: t("Service Class Code"),
                                        field: "service_class_code",
                                        render: (rowData) => (
                                            <>
                                            <div className={`d-xl-none tc d-md-none d-lg-none`}
                                            >
                                                {t("Service Class Code")}
                                            </div>
                                        <div
                                            className="col-lg-8 view-label p"
                                            onClick={() => handleView(rowData.id)}
                                            >
                                            {rowData.service_class_code}
                                        </div>
                                            </>
                                        ),
                                        headerStyle: {
                                        verticalAlign: "inherit",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        },
                                        cellStyle: {
                                        textAlign: "left",
                                        fontSize: 12,
                                        },
                                    },
                                    {
                                        title: t("Immediate Destination Name"),
                                        field: "immediate_destination_name",
                                        render: (rowData) => (
                                            <>
                                            <div className={`d-xl-none tc d-md-none d-lg-none`}
                                            >
                                                {t("Immediate Destination Name")}
                                            </div>
                                        <div
                                            className="col-lg-8 view-label p"
                                            onClick={() => handleView(rowData.id)}
                                            >
                                            {rowData.immediate_destination_name}
                                        </div>
                                            </>
                                        ),
                                        headerStyle: {
                                        verticalAlign: "inherit",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        },
                                        cellStyle: {
                                        textAlign: "left",
                                        fontSize: 12,
                                        },
                                    },
                                    {
                                        title: t("Immediate Origin Name"),
                                        field: "immediate_origin_name",
                                        render: (rowData) => (
                                            <>
                                            <div className={`d-xl-none tc d-md-none d-lg-none`}
                                            >
                                                {t("Immediate Origin Name")}
                                            </div>
                                        <div
                                            className="col-lg-8 view-label p"
                                            onClick={() => handleView(rowData.id)}
                                            >
                                            {rowData.immediate_origin_name}
                                        </div>
                                            </>
                                        ),
                                        headerStyle: {
                                        verticalAlign: "inherit",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        },
                                        cellStyle: {
                                        textAlign: "left",
                                        fontSize: 12,
                                        },
                                    },
                                    {
                                        title: t("Company Identification"),
                                        field: "company_identification",
                                        render: (rowData) => (
                                            <>
                                            <div className={`d-xl-none tc d-md-none d-lg-none`}
                                            >
                                                {t("Company Identification")}
                                            </div>
                                        <div
                                            className="col-lg-8 view-label p"
                                            onClick={() => handleView(rowData.id)}
                                            >
                                            {rowData.company_identification}
                                        </div>
                                            </>
                                        ),
                                        headerStyle: {
                                        verticalAlign: "inherit",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        },
                                        cellStyle: {
                                        textAlign: "left",
                                        fontSize: 12,
                                        },
                                    },
                                    ]}
                                    data={query =>
                                        new Promise((resolve, reject) => {
                                            let url = API + "company/achproviders/?";
                                            url += "per_page=" + query.pageSize;
                                            url += "&page=" + (query.page + 1);
                                            url += "&search=" + query.search;

                                            fetch(url, { headers: authHeader() })
                                                .then(response => response.json())
                                                .then(result => {
                                                 setTotalCount(result.total || 0); // Update totalCount state

                                                    resolve({
                                                        data:
                                                            query.orderBy && query.orderDirection
                                                                ? _.orderBy(
                                                                    result.data || [],
                                                                    [query.orderBy.field],
                                                                    [query.orderDirection]
                                                                )
                                                                : result.data || [],
                                                        page: (result.page || 1) - 1,
                                                        totalCount: result.total || 0,
                                                    });
                                                })
                                                .catch(() => {
                                                    resolve({
                                                        data: [],
                                                        page: 0,
                                                        totalCount: 0,
                                                    });
                                                });
                                        })
                                    }
                                    localization={{
                                        toolbar: {
                                            searchPlaceholder: t("Search ACH Provider"),
                                        },
                                    }}
                                    actions={[
                                        {
                                        icon: () =>
                                        
                                             
                                            <img
                                                src={
                                                process.env.PUBLIC_URL +
                                                "/static/images/ic-edit.svg"
                                                }
                                                alt="edit"
                                            />
                                          
                                        
                                              ,
                                        tooltip: "Edit",
                                        onClick:
                                            
                                             (event, rowData) => {
                                                handleEdit(rowData.id);
                                                }
                                            ,
                                        },
                                        // {
                                        // icon: () => (
                                           
                                        //     <img
                                        //     src={
                                        //         process.env.PUBLIC_URL +
                                        //         "/static/images/ic-delete.svg"
                                        //     }
                                        //     alt="delete"
                                        //     />
                                        // ),
                                        // tooltip: "Delete",
                                        // onClick:(event, rowData) => {
                                        //     handelDelete(rowData.id);
                                        // },
                                        // },
                                    ]}
                                    components={{
                                        Toolbar: props => (
                                            <div className="MuiToolbar-root MTableToolbar-spacer-21 my-temp-class">
                                                <MTableToolbar {...props} />
                                                {/* {permissionsArray.includes('add_achprovider') && customerPermission !== 'Customer' && ( */}
                                                {totalCount !== 1 &&
                                                    <Link
                                                        className="navbar-brand m-0"
                                                        to="/addachprovider"
                                                    >
                                                        <button
                                                            className="add-party add btn btn-primary mb-0"
                                                            id="add-task"
                                                        >
                                                            +&nbsp; {t("Add ACH Provider")}
                                                        </button>
                                                    </Link>
                                    }   
                                                {/* )} */}
                                            </div>
                                        ),
                                    }}
                                    options={{
                                        headerStyle: {
                                            backgroundColor: "white",
                                            color: "#245C7F",
                                            fontSize: 12,
                                        },
                                        rowStyle: (rowData, index) => {
                                            if (index % 2) {
                                                return { backgroundColor: "#fff" };
                                            }
                                        },
                                        sorting: true,
                                        search: false,
                                        toolbar: true,
                                        paging: true,
                                        pageSize: 10, // initial page size
                                        emptyRowsWhenPaging: false,
                                        pageSizeOptions: [10, 20, 25, 50],
                                        paginationType: "stepped",
                                        showFirstLastPageButtons: false,
                                        exportAllData: true,
                                        exportButton: false,
                                        exportFileName: "ACH_Providers",
                                        exportPdf: (data, columns) => {
                                            const doc = new jsPDF();
                                            const columnTitles = data.map(
                                                (columnDef) => columnDef.title
                                            );
                                            const pdfData = columns.map((rowData) =>
                                                data.map(
                                                    (columnDef) => rowData[columnDef.field]
                                                )
                                            );
                                            // doc.autoTable({
                                            autoTable(doc,{
                                                head: [columnTitles],
                                                body: pdfData,
                                            });
                                            doc.save(`ACH_Providers.pdf`);
                                        },
                                        actionsColumnIndex: -1,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AchProviders;